import { Form, InputNumber } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { isNotBlank } from '../../reducers/util';
import styles from './AgeSelector.module.scss'
import {getCriterionValue} from "../../containers/CohortBuilder/criterion";

const FROM_FIELD_NAME = "fromAge"
const TO_FIELD_NAME = "toAge"

interface Props {
    form: FormInstance
    criterion?: any
}

export const MIN_AGE = 0
export const MAX_AGE = 120

const AgeSelector = ({ form, criterion }: Props) => {

    const startAndEndAgeIsValid = (rule: any, value: any) => {
        const fromAge = form.getFieldValue(FROM_FIELD_NAME)
        const toAge = form.getFieldValue(TO_FIELD_NAME)
        if (isNotBlank(fromAge) && isNotBlank(toAge) && fromAge > toAge) {
            return Promise.reject('Start age cannot be after end age.')
        } else {
            return Promise.resolve()
        }
    }

    return <div className={styles.minMaxContainer}>
        <Form.Item key={FROM_FIELD_NAME} name={FROM_FIELD_NAME} label="Start Age" initialValue={getCriterionValue(criterion, FROM_FIELD_NAME)} rules={[{ validator: startAndEndAgeIsValid }]}>
            <InputNumber min={MIN_AGE} max={MAX_AGE} />
        </Form.Item>
        <Form.Item key={TO_FIELD_NAME} name={TO_FIELD_NAME} label="End Age" initialValue={getCriterionValue(criterion, TO_FIELD_NAME)} rules={[{ validator: startAndEndAgeIsValid }]} style={{paddingLeft: '5px'}}>
            <InputNumber min={MIN_AGE} max={MAX_AGE} />
        </Form.Item>
    </div>

}

export default AgeSelector